<div class="chart-modal">
  <!-- Header row -->
  <div class="chart-modal__header">
    <!-- Left: Title + Trend -->
    <div class="title-and-trend">
      <h3 class="chart-title">{{ 'driverOverview.widgets.kilometersDriven' | transloco }}</h3>
      @if (!isLoading && hasData()) {
        <app-graph-trend-icon
          [percentageChange]="percentageChange"
          [formattedChange]="formatPercentChange()"
          [formatValue]="formatValue()"
          [isUptrendPositive]="isUptrendPositive()">
        </app-graph-trend-icon>
      }
    </div>

    <!-- Right: Filters + close -->
    <div class="chart-modal__header-actions">
      <div class="filters d-flex align-items-center gap-2">
        <div class="date-height">
          <app-date-filter
            [filter]="dateFilter"
            [isButtonIntervalSelector]="true"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>
        <app-account-filter
          [filter]="accountFilter"
          (filterChanged)="onAccountFilterChange($event)">
        </app-account-filter>
      </div>

      <!-- close -->
      <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="close()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
          </path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Chart area -->
  <div class="chart-modal__body">
    @defer (on timer(100ms)) {
      @if (!isLoading && hasError) {
        <div class="chart-modal__empty">
          <app-graph-error-state></app-graph-error-state>
        </div>
      } @else if (!isLoading && hasData()) {
        <div class="chart-modal__chart">
          <app-multi-line-chart
            class="chart-fill"
            [data]="chartData"
            [series]="series"
            [legend]="legendItems"
            [yTicks]="yTicks"
            [yAxisFormat]="yAxisFormatter"
            [chartHeight]="chartHeight"
            [xPadding]="0.5"
            [tooltipFormat]="formatTooltipValue">
          </app-multi-line-chart>
        </div>
      } @else if (!isLoading && !hasData()) {
        <div class="chart-modal__empty">
          <app-empty-state></app-empty-state>
        </div>
      }
    }

    @if (isLoading) {
      <div class="chart-modal__loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    }
  </div>
</div>